// src/components/network/messaging/MessagePreview.jsx
import React from 'react';
import { Building, User, Check, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';

const MessagePreview = ({ conversation, onClick }) => {
  const { participant, lastMessage, lastMessageAt, unreadCount } = conversation;
  
  const truncateMessage = (message) => {
    if (!message) return '';
    return message.length > 40 ? message.substring(0, 37) + '...' : message;
  };
  
  const formatTime = (date) => {
    if (!date) return '';
    try {
      return formatDistanceToNow(new Date(date), { addSuffix: true });
    } catch (e) {
      return '';
    }
  };
  
  return (
    <div 
      onClick={onClick}
      className={`p-3 flex items-start cursor-pointer ${
        unreadCount > 0 ? 'bg-purple-50' : 'hover:bg-gray-50'
      }`}
    >
      <div className="w-10 h-10 rounded-full bg-gray-100 mr-3 flex-shrink-0 overflow-hidden">
        {participant.type === 'business' && participant.logoUrl ? (
          <img 
            src={participant.logoUrl} 
            alt={participant.name} 
            className="w-full h-full object-cover"
          />
        ) : participant.type === 'business' ? (
          <div className="w-full h-full flex items-center justify-center bg-purple-100 text-[#190192]">
            <Building size={18} />
          </div>
        ) : participant.photoURL ? (
          <img 
            src={participant.photoURL} 
            alt={participant.name} 
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-200 text-gray-600">
            <User size={18} />
          </div>
        )}
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-center mb-1">
          <h4 className="font-medium text-gray-900 truncate">{participant.name}</h4>
          <span className="text-xs text-gray-500 whitespace-nowrap">
            {formatTime(lastMessageAt)}
          </span>
        </div>
        
        <div className="flex items-center">
          <p className={`text-sm truncate ${unreadCount > 0 ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
            {truncateMessage(lastMessage)}
          </p>
          
          {unreadCount > 0 && (
            <span className="ml-2 flex-shrink-0 bg-[#190192] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
              {unreadCount > 9 ? '9+' : unreadCount}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MessagePreview;